import { render, staticRenderFns } from "./SwapsNewSell.vue?vue&type=template&id=147c32e8"
import script from "./SwapsNewSell.vue?vue&type=script&lang=ts"
export * from "./SwapsNewSell.vue?vue&type=script&lang=ts"
import style0 from "./SwapsNewSell.vue?vue&type=style&index=0&id=147c32e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports